define('lib/Podio.Transport.Recurrence',['require','lib/Podio.Transport','lib/Podio.Routes'],function (require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function update(refType, refId, requestData, callback) {
    transport.putJSON(routes.recurrence_path(refType, refId), {
      'requestData': {recurrence: requestData}
    }, callback);
  }

  function destroy(refType, refId, callback) {
    transport.deleteJSON(routes.recurrence_path(refType, refId), {}, callback);
  }

  return {
    update: update,
    destroy: destroy
  };

});



